"use client";


import { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from "react";
// import "./Marquee.css";
// import { Stack } from "@fastlooptech/layout-components";
import { spaceUnit } from "@/helpers/utils.helper";
import classNames from "classnames";
import BaseTypography from "@/client/foundations/Typography/BaseTypography";
import { Stack } from "@/layouts/LayoutComponents";

const SPEED = 60;

interface MarqueeProps {
  "data-test-id"?: string;
  /**
   * The children of the Marquee component.
   * @type string;
   * @required
   */
  children: string;
  /**
   * The animation direction of the Marquee component.
   * @type 'normal' | 'reverse' | 'alternate' | 'alternate-reverse'
   * @required
   */
  direction?: "normal" | "reverse" | "alternate" | "alternate-reverse";
}

export function Marquee(props: MarqueeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const marqueeRef = useRef<HTMLElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [marqueeWidth, setMarqueeWidth] = useState(0);
  const [duration, setDuration] = useState(0);

  const animationVars = useMemo(
    () => ({
      "--duration": duration + "s",
      "--direction": props.direction,
    }),
    [duration, props.direction],
  );

  const calculateWidth = useCallback(() => {
    if (marqueeRef.current && containerRef.current) {
      setContainerWidth(containerRef.current.getBoundingClientRect().width);
      setMarqueeWidth(marqueeRef.current.getBoundingClientRect().width);
    }

    if (marqueeWidth < containerWidth) {
      setDuration(containerWidth / SPEED);
    } else {
      setDuration(marqueeWidth / SPEED);
    }
  }, [marqueeWidth, containerWidth, marqueeRef, containerRef]);

  useEffect(() => {
    calculateWidth();
    window.addEventListener("resize", calculateWidth);
    return () => {
      window.removeEventListener("resize", calculateWidth);
    };
  }, [calculateWidth, marqueeRef, containerRef]);

  const typographyStyle = "marquee font-marquee text-display-xl sm:text-display-xl-sm md:text-display-xl-md xl:text-display-xl-xl";

  return (
    <Stack
      gap={spaceUnit * 5}
      hAlignContent="center"
      data-test-id={props["data-test-id"]}
      className="overflow-hidden"
      ref={containerRef}
    >
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames("text-interactive-marquee", typographyStyle)}
        ref={marqueeRef}
      >
        {props.children}
      </BaseTypography>
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames(typographyStyle)}
      >
        {props.children}
      </BaseTypography>
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames("text-interactive-marquee", typographyStyle)}
      >
        {props.children}
      </BaseTypography>
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames(typographyStyle)}
      >
        {props.children}
      </BaseTypography>
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames("text-interactive-marquee", typographyStyle)}
      >
        {props.children}
      </BaseTypography>
      <BaseTypography
        style={animationVars as CSSProperties}
        component="h2"
        role="heading"
        aria-level="2"
        title={props.children}
        className={classNames(typographyStyle)}
      >
        {props.children}
      </BaseTypography>
    </Stack>
  );
}
